export default __webpack_public_path__ + "static/media/blinking.aef4bee6.mp3";